export var TOP_SUGGEST_POSITION = "\n  .ymaps-{version}-search__suggest {\n    top: auto !important;\n    bottom: 30px;\n  }\n";